import apiClient from '@/plugins/axios'

export default {
  getModalidades(filter) {
    return apiClient.post('modalidade/index', filter)
  },

  getModalidade(id) {
    return apiClient.get(`modalidade/${id}`)
  },

  postModalidade(modalidade) {
    return apiClient.post(`modalidade`, { modalidade })

  },

  putModalidade(id, modalidade) {
    return apiClient.put(`modalidade/${id}`, { modalidade })

  },

  deleteModalidade(id) {
    return apiClient.delete(`modalidade/${id}`)

  },

  getPagination(url) {
    return apiClient.post(url)
  }

}


// WEBPACK FOOTER //
// ./src/views/Modalidade/_services/ModalidadeService.js